import React, { FC } from 'react'
import { formatPrice } from '../../atoms/FormatPrice';

interface StockPricesContainerProps {
    stockPrices: any,
    handleStockClick: any
}
const StockPricesContainer: FC<StockPricesContainerProps> = (props) => {
    const { stockPrices, handleStockClick } = props;
    return (
        <div>
            <div className='pricetext-container-cp-container'>
                <div className='pricetext-container-cp cp-display'>Current Price</div>
                <div className='pricetext-container-cp'>Current Price</div>
            </div>
            <div className='prices-container-cp' style={{ padding: "0px", overflow: "hidden" }}>
                {stockPrices?.stocks_data?.map((stock: any) => {
                    return (
                        <div className='player-prf-conatiner-stock company-height' onClick={() => handleStockClick(stock)} style={{ cursor: "pointer" }}>
                            <img src={stock?.image}
                                className='company-profile' draggable="false"
                                alt='profile-img'
                                onContextMenu={(e) => e.preventDefault()} />
                            <div className='pricetext-container'>
                                <div className='pricetext-subname'>{stock?.name}</div>
                                <div className='pricetext-name'> {formatPrice(stock.current_price)}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>

    )
}

export default StockPricesContainer